import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }

  OnLogoClick() {
    window.location.href = "https://www.bcbsri.com/developers";
  }
}
